import { SocketRoomPrefix } from "@features/builder/types"
import { Avatar, Grid, Tooltip } from "@mui/material"
import { getInitials, stringToColor } from "utils/string"
import { memberLockAtom } from "@features/builder/hooks/socketIOHooks"
import { useAtomValue } from "jotai"
import { getUniqueMembers } from "@features/builder/TopActionBar/SubscribersIndicator/helpers"

type SubscribersIndicatorProps = {
  graphId: string | undefined
}

const SubscribersIndicator = (props: SubscribersIndicatorProps) => {
  const roomName = `${SocketRoomPrefix.CRDT}-${props.graphId}`
  const membersByRoom = useAtomValue(memberLockAtom)
  const roomMembers = membersByRoom.get(roomName)
  const uniqueMembers = getUniqueMembers(roomMembers)

  return (
    <Grid container gap={1}>
      {Array.from(uniqueMembers.values()).map(({ member }, i) => (
        <Grid item key={`${member.name}-${i}`}>
          <Tooltip title={member.name}>
            <Avatar
              sx={{
                backgroundColor: stringToColor(member.name),
                width: 28,
                height: 28,
                fontSize: "13px",
                letterSpacing: "1px",
                cursor: "pointer",
              }}
            >
              {getInitials(member.name)}
            </Avatar>
          </Tooltip>
        </Grid>
      ))}
    </Grid>
  )
}

export default SubscribersIndicator
